export const POST = 'POST';
export const GET = 'GET';